export default __webpack_public_path__ + "static/media/spice.2ae8ba12.svg";